import { QueryClient } from "@tanstack/react-query";

export function normalizeProposalIdParam(
  proposalId: string | number | string[] | undefined | null
): string | undefined {
  if (proposalId == null || proposalId === "") {
    return undefined;
  }
  if (typeof proposalId === "string") {
    return proposalId;
  }
  if (typeof proposalId === "number") {
    return String(proposalId);
  }
  const first = proposalId[0];
  if (typeof first === "string") {
    return first;
  }
  if (typeof first === "number") {
    return String(first);
  }
  return undefined;
}

export const PROPOSAL_VIEW_INFO_QUERY_ROOTS = [
  "proposalDetails",
  "proposalSituation",
  "analysisReasons",
  "proposalDocuments"
] as const;

/**
 * Marks proposal detail screen queries as stale and refetches observers.
 * Used when re-entering the screen so status (e.g. after credit engine) is current.
 */
export function invalidateProposalViewInfoQueries(
  queryClient: QueryClient,
  proposalId: string
): void {
  for (const root of PROPOSAL_VIEW_INFO_QUERY_ROOTS) {
    void queryClient.invalidateQueries({
      queryKey: [root, proposalId],
      exact: true
    });
  }
}

/**
 * Drops previously resolved data and refetches active proposal-detail queries.
 * This prevents stale values from being rendered while a focused screen updates.
 */
export async function resetProposalViewInfoQueries(
  queryClient: QueryClient,
  proposalId: string
): Promise<void> {
  await Promise.all(
    PROPOSAL_VIEW_INFO_QUERY_ROOTS.map((root) =>
      queryClient.resetQueries({
        queryKey: [root, proposalId],
        exact: true
      })
    )
  );
}
